import { createContext, useContext } from 'react';
import { User } from '../types';

export interface UserContextType {
  users: User[];
  loading: boolean;
  error: unknown;
  getUserColor: (name: string) => string;
}

export const UserContext = createContext<UserContextType | undefined>(
  undefined
);

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};
